import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class NotificationService {
  static async list (params) {
    const { data } = await axios.get(`${url}/notification`, { headers, params })
    return data?.data
  }

  static async updateByParams (body) {
    const { data } = await axios.put(`${url}/notification`, body, { headers })
    return data?.data
  }
}
